<template>
  <div class="view">
    <img alt="logo" class="logo" src="@/assets/logo.png">
    <p v-html="$t('home.part1')"></p>
    <div class="img-block mosaik" v-if="extImages && extImages.length > 3">
      <div class="left">
        <div class="top">
          <img :src="getImage(extImages[0]._id)" />
        </div>
        <div class="bottom">
          <img :src="getImage(extImages[1]._id)" />
          <img :src="getImage(extImages[2]._id)" />
        </div>
      </div>
      <div class="right">
        <img :src="getImage(extImages[3]._id)" />
      </div>
    </div>
    <p v-html="$t('home.part2')"></p>
    <div class="img-block rooms" v-if="mainImages && mainImages.length > 3">
      <div class="row">
        <div class="room" v-for="pic in mainImages" :key="pic._id">
          <img :src="getImage(pic._id)" />
        </div>
      </div>
      <router-link class="button" to="/rooms">{{$t('home.rooms')}}</router-link>
    </div>
    <p v-html="$t('home.part3')"></p>
    <div class="img-block cahors" v-if="cahorsImages && cahorsImages.length > 1">
      <div class="row">
        <img class="left" :src="getImage(cahorsImages[0]._id)" />
        <img class="right" :src="getImage(cahorsImages[1]._id)" />
      </div>
      <router-link class="button" to="/discover">{{$t('home.discover')}}</router-link>
    </div>
    <p v-html="$t('home.part4')"></p>
    <div class="img-block rooms" v-if="intImages">
      <div class="row">
        <div class="room" v-for="pic in intImages" :key="pic._id">
          <img :src="getImage(pic._id)" />
        </div>
      </div>
      <router-link class="button" to="/gallery">{{$t('home.gallery')}}</router-link>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'Home',
  computed: {
    ...mapState({
      images: state => state.images.list
    }),
    mainImages() {
      let array = []
      if (this.images) {
        this.images.map(i => {
          if (i.tags.includes('main'))  {
            array.push(i)
          }
        })
      }
      return array
    },
    extImages() {
      let array = []
      if (this.images) {
        this.images.map(i => {
          if (i.tags.includes('ext')) {
            array.push(i)
          }
        })
      }
      return array
    },
    intImages() {
      let array = []
      if  (this.images) {
        this.images.map(i => {
            if (i.tags.includes('int')) {
              array.push(i)
            }
          }
        )
      }
      return array
    },
    cahorsImages() {
      let array = []
      if  (this.images) {
        this.images.map(i => {
          if (i.tags.includes('cahors')) {
            array.push(i)
          }
        })
      }
      return array
    }
  },
  mounted () {
    // Api.testApi()
  },
  methods: {
    getImage(id) {
      let path = ''
      this.images.map(i => {
        if (i._id === id) {
          path = i.source.path
        }
      })
      return path
    },
  }
}
</script>


<style lang="scss" scoped>
@import "../index.scss";
.view {
  box-sizing: border-box;
  padding: 0 50px;
  @media (max-width: 500px) {
    padding: 0 10px;
  }
}
img.logo {
  margin: 50px auto;
  max-width: 700px;
  width: 100%;
}
p {
  max-width: 1440px;
  margin: auto;
  margin-bottom: 40px;
  text-align: left;
  font-size: 22px;
}

.img-block {
  margin: 50px auto;
  &.mosaik {
    display: flex;
    flex-direction: row;
    max-width: 1440px;
    @media (max-width: 800px) {
      flex-wrap: wrap;
    }
    div  {
      box-sizing: border-box;
      padding:10px 0px;
      overflow: hidden;
      border-radius: 4px;
    }
    .left, .right {
      display: flex;
      flex: 1;
      min-width: 50%;
      flex-direction: column;
      height: 600px;
      .top {
        width: 100%;
        height: 350px;
        overflow: hidden;
        img {
          pointer-events: none;
          border-radius: 4px;
          width: 100%;
        }
        @media (max-width: 500px) {
          height: auto;
        }
      }
      .bottom {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        max-height: 300px;
        min-height: 250px;
        img {
          pointer-events: none;
          border-radius: 4px;
          flex: 1;
          max-width: calc(50% - 20px);
        }
      }

    }
    .right {
      min-width: 300px;
      img {
        pointer-events: none;
        border-radius: 4px;
        margin: 10px;
        height: calc(100% - 20px);
      }
      @media (max-width: 500px) {
        display: none;
      }
    }
    img {
      pointer-events: none;
      border-radius: 4px;
      object-fit: cover;
      max-width: 100%;
    }
  }
  .button {
    margin: 10px auto;
    max-width: 200px;
      text-decoration: none;
  }
  &.rooms {
    display: flex;
    flex-direction: column;
    max-width: 1440px;
    .row {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;

      .room {
        width: 360px;
        padding: 20px;
        padding-left: 0px;
        box-sizing: border-box;
        img {
          pointer-events: none;
          border-radius: 4px;
          object-fit: cover;
          min-width: 100px;
          width: 100%;
        }

        @media (max-width: 500px) {
          width: 100%;
          max-width: 360px;
          padding: 0;
          margin: 10px auto;
        }
      }
    }
    .button {
      margin: 10px auto;
      max-width: 200px;
      text-decoration: none;

    }
  }
  .row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    // flex-wrap: wrap;
    align-items: center;
    margin: auto;

    img {
      pointer-events: none;
      object-fit: cover;
    }

    .left {
      width: 100%;
      min-width: 400px;
      // max-width: 800px;
      height: 400px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    .right {
      width: 400px;
      height: 400px;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
    @media (max-width: 800px) {
      flex-direction: column;
      img {
        border-radius: 4px;
      }
      .right {
        margin-top: 20px;
        width: 100%;
      }
    }
  }
  .column {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    width: 100%;
    img {
      pointer-events: none;
      object-fit: cover;
      margin: 10px;
      max-width: 720px;
      border-radius: 4px;
    }
  }

}

@media (max-width: 500px) {
  .cahors {
    .left {
      display: none;
    }
    .right {
      height: auto !important;
    }
  }
}

</style>